import type { ReactNode } from 'react';
import { Flex, Typography } from 'antd';

const { Text } = Typography;

type LabelValueProps = {
  label: string;
  value: ReactNode;
  align?: 'left' | 'right';
};

export function LabelValue({ label, value, align = 'left' }: LabelValueProps) {
  return (
    <Flex vertical gap={0} align={align === 'right' ? 'flex-end' : 'flex-start'}>
      <Text type="secondary" style={{ fontSize: 12, lineHeight: '18px' }}>
        {label}
      </Text>
      {typeof value === 'string' || typeof value === 'number' ? (
        <Text strong style={{ fontSize: 14, lineHeight: '20px' }}>
          {value}
        </Text>
      ) : (
        value
      )}
    </Flex>
  );
}
